class SessionClosedError extends Error {
  constructor (message, response) {
    super(message)
    this.name = 'SessionClosedError'
    this.code = 'sessionClosed'
    this.response = response
  }
}

export default SessionClosedError
